import React, { useState } from "react";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronLeft } from "lucide-react";
import { useTunnelData } from "../TunnelContext";
import { Redirect } from "react-router-dom";
import OAButton from "../components/OAButton";

export const StepConfirmation = () => {
  const { t } = useTranslation();
  const { tunnel } = useTunnelData();
  const [step, setStep] = useState("MIDDLE_CONFIRMATION");

  if (step === "CONFIRM") return <Redirect push to="/confirmation" />;
  if (!tunnel.club) return <Redirect push to={"/"} />;
  if (step === "SEPA" || !tunnel.stripe) return <Redirect push to={"/sepa"} />;
  return (
    <>
      <div className="bg-oaBackgroundColor min-h-screen w-full">
        <Link
          to="/user"
          className="absolute left-4 top-5 md:left-20 flex flex-row hover:text-oaRed transition-all duration-300"
        >
          <ChevronLeft className="mr-2" />
          {t("previous_step")}
        </Link>
        <section className="w-full h-full px-5 py-4 md:px-20 md:py-10">
          <div className="animate-fade-in-left">
            <Breadcrumbs />
          </div>
        </section>
        <div className="flex flex-col text-center mx-4 md:mx-[25%] gap-4 mt-6">
          <h1 className="font-bold text-xl">{t("middle_confirmation.title")}</h1>

          <h5>{t("middle_confirmation.subtitle")}</h5>

          <p>{t("middle_confirmation.description")}</p>

          <OAButton className="h-10 text-xl" onClick={() => setStep("SEPA")}>
            {t("middle_confirmation.button.next")}
          </OAButton>
          <OAButton className="h-10 text-xl" variant="outline" onClick={() => setStep("CONFIRM")}>
            {t("middle_confirmation.button.confirm")}
          </OAButton>
        </div>
      </div>
      <footer>
        <Footer />
      </footer>
    </>
  );
};
